import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { filter, switchMap } from 'rxjs';

import { Product, ProductService } from '@spartacus/core';

import { BrandThemesEnum, IHeading, PositionEnum, SdSpyTargetDirective } from '@seb/web-design-system/core';
import { IDocument, SdDocumentsComponent } from '@seb/web-design-system/documents';

import { AbstractComponent } from '../abstract-component.component';
import { WrapperComponent } from '../../../components/static/core';
import { IFUComponentInterface } from '../../../models';
import { TrackingService } from '../../../services';
import { ProductScopeEnum } from '../../../enums';
import { DocumentMapper } from '../../../mappers';

@Component({
  selector: 'wc-ifu',
  templateUrl: './ifu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdSpyTargetDirective,
    WrapperComponent,
    SdDocumentsComponent
  ]
})
export class IFUComponent extends AbstractComponent<IFUComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  heading: IHeading;
  titleThemesConfig = BrandThemesEnum.brand;
  textConfig = PositionEnum.center;
  productName: string;
  documents: IDocument[];

  constructor(
    private productService: ProductService,
    private documentMapper: DocumentMapper,
    private trackingService: TrackingService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  override mandatoryFunction = (cmp: IFUComponentInterface): boolean => {
    return !!cmp.product;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.pipe(
        switchMap((cmp: IFUComponentInterface) => (
          this.productService.get(cmp.product, ProductScopeEnum.IFU))
        ),
        filter((product) => (
          product?.instructionsForUse?.instructionsForUse?.length > 0)
        )
      ).subscribe((product: Product) => {
        this.documents = this.documentMapper.getInstructionsForUseToDocument(
          product.instructionsForUse.instructionsForUse
        );

        this.productName = product.name;

        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }

  onClick(document: IDocument): void {
    this.trackingService.sendEvent('documentationDownload', {
      productName: this.productName,
      documentationName: document.title
    });
  }
}
